'use client';
import { IManufacturingProcess } from '@/src/interfaces/generated/contentful';
import {
  PageSection,
  Box,
  Paragraph,
  Heading,
} from '@/src/packages/components';
import { PageSectionStack } from '@/src/packages/components/templates/PageSectionStack';
import { VideoManufacturing } from '@/src/packages/components/ui/Video';
import { TemplateSidebar } from '@/src/packages/components/templates/TemplateSidebar';
import { ManufacturingLinks } from '@/src/packages/components/ui/Footer/Footer.config';
import Image from 'next/image';

type IMakerProps = {
  manufacturingProcess: IManufacturingProcess;
};

export const ManufacturingProcess = (props: IMakerProps) => {
  const { manufacturingProcess } = props;

  return (
    <TemplateSidebar
      title={manufacturingProcess.fields.title}
      links={ManufacturingLinks}
    >
      <PageSectionStack>
        <Box className="space-y-8">
          <Box className="grid grid-cols-12">
            <Box className="col-span-12 lg:col-span-6">
              <Paragraph size="large">
                {manufacturingProcess.fields.description}
              </Paragraph>
            </Box>
          </Box>
          <VideoManufacturing />
        </Box>

        <PageSection>
          <Box className="space-y-gutter">
            {manufacturingProcess &&
              manufacturingProcess.fields.steps &&
              manufacturingProcess.fields.steps.map((item, i) => {
                const image = item.fields.images && item.fields.images[0];

                return (
                  <Box
                    className="bg-background-secondary grid grid-cols-12"
                    key={i}
                  >
                    <Box className="col-span-12 space-y-8 px-8 py-6 lg:col-span-6">
                      <Box className="space-y-2">
                        <Heading
                          as="h3"
                          size="h2"
                          className="font-serif text-2xl leading-none"
                        >
                          {item.fields.name}
                        </Heading>
                        <Paragraph className="text-text-secondary">
                          {item.fields.description}
                        </Paragraph>
                      </Box>
                    </Box>

                    <Box className="relative col-span-12 aspect-video lg:col-span-6 lg:aspect-square">
                      <Image
                        alt={`${item.fields.name} cover image`}
                        src={image.fields.file.url}
                        fill
                        className="object-cover"
                        sizes="(max-width: 1024px) 100vw, 50vw"
                      />
                    </Box>
                  </Box>
                );
              })}
          </Box>
        </PageSection>
      </PageSectionStack>
    </TemplateSidebar>
  );
};
